<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="3"
        offset-md="5"
        align="right"
      >
        <nueva-solicitud-dialog-component />
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <v-text-field
          v-model="buscaPersonal"
          color="secondary"
          background-color="primary"
          rounded
          filled
          dense
          placeholder="Buscar personal por nombre, edad, municipio o estado..."
          append-icon="mdi-magnify"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card
          color="primary"
          class="card"
        >
          <v-data-table
            :headers="solicitudesHeaders"
            :items="solicitudes"
            class="transparent"
          >
            <template #[`item.opciones`]="{ item }">
              <div class="d-inline-flex">
                <v-tooltip
                  bottom
                  color="black"
                >
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="secondary--text mx-2"
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="openInformacionExtraDialog(item)"
                    >
                      <v-icon>mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver información extra</span>
                </v-tooltip>
              </div>
            </template>
            <template #[`item.programaciones_agendadas`]="{ item }">
              <v-icon
                v-if="existsProgramacionBySolicitud(item.idSolicitudes)"
                color="success"
              >
                mdi-check
              </v-icon>
              <v-icon v-else>
                mdi-minus
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <informacion-extra-dialog-component
      :active="informacionExtraDialog"
      :solicitud="selectedSolicitud"
      @close="informacionExtraDialog = false"
    />
    <informacion-programacion-dialog-component
      :active="informacionProgramacionDialog"
      :programacion="selectedProgramacion"
      :derivaciones="derivaciones"
      @close="informacionProgramacionDialog = false"
    />
    <nueva-programacion-dialog-component
      :active="nuevaProgramacionDialog"
      :solicitud="selectedSolicitud"
      @close="nuevaProgramacionDialog = false"
    />
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import InformacionExtraDialogComponent from '../../components/programacion/InformacionExtraDialogComponent.vue';
import NuevaSolicitudDialogComponent from '../../components/programacion/NuevaSolicitudDialogComponent.vue';
import InformacionProgramacionDialogComponent from '../../components/programacion/InformacionProgramacionDialogComponent.vue';
import NuevaProgramacionDialogComponent from '../../components/programacion/NuevaProgramacionDialogComponent.vue';

export default {
  name: 'SolicitudesView',
  components: {
    InformacionExtraDialogComponent,
    NuevaSolicitudDialogComponent,
    NuevaProgramacionDialogComponent,
    InformacionProgramacionDialogComponent,
  },

  data() {
    return {
      buscaPersonal: '',
      ordenAlfabetico: 0,
      solicitudesHeaders: [
        {
          text: 'Fecha',
          value: 'fecha',
        },
        {
          text: 'Oficio',
          value: 'oficio',
        },
        {
          text: 'Asunto',
          value: 'asunto',
        },
        {
          text: 'Opciones',
          value: 'opciones',
          sortable: false,
          align: 'center',
        },
      ],

      // Dialogs
      informacionExtraDialog: false,
      editarSolicitudDialog: false,
      nuevaProgramacionDialog: false,
      informacionProgramacionDialog: false,

      selectedSolicitud: {},
      selectedProgramacion: {},
    };
  },

  computed: {
    ...mapGetters('solicitudes', {
      solicitudes: 'getSolicitudes',
    }),

    ...mapGetters('programacionEvaluacion', {
      programaciones: 'getProgramacionesEvaluaciones',
    }),

    ...mapGetters('derivaciones', {
      derivaciones: 'getDerivaciones',
    }),
  },

  methods: {
    ...mapActions('derivaciones', ['fetchDerivacionesByProgramacionEvaluacion']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('solicitudes', ['SET_ID_SOLICITUD']),

    openInformacionExtraDialog(solicitud) {
      this.selectedSolicitud = solicitud;
      this.informacionExtraDialog = true;
    },

    openEditarSolicitudDialog(solicitud) {
      this.selectedSolicitud = solicitud;
      this.editarSolicitudDialog = true;
    },

    openNuevoExpedienteDialog(solicitud) {
      this.selectedSolicitud = solicitud;
      this.SET_ID_SOLICITUD(solicitud.idSolicitudes);
      this.nuevaProgramacionDialog = true;
    },

    async openInformacionProgramacionDialog(solicitud) {
      this.SET_SNACKBAR_MESSAGE('Cargando fechas programadas...');
      this.selectedProgramacion = this.programaciones.find(
        (programacion) => programacion.fk_idSolicitud === solicitud.idSolicitudes,
      );
      await this.fetchDerivacionesByProgramacionEvaluacion(
        this.selectedProgramacion.idProgramacionEvaluacion,
      );
      this.informacionProgramacionDialog = true;
    },

    existsProgramacionBySolicitud(idSolicitud) {
      return this.programaciones.some(
        (programacion) => programacion.fk_idSolicitud === idSolicitud,
      );
    },
  },
};
</script>
